<template>
  <div class="form-group">
    <label class="control-label" v-if="label" v-html="label" />
    <br/>
    <bootstrap-toggle
      ref="input"
      :class="['form-control']"
      :name="name"
      :id="id"
      :data-vv-as="label"
      :disabled="disabled"
      :options="options"
      :value="value"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import BootstrapToggle from "vue-bootstrap-toggle";

export default {
  inject: ["$validator"],
  name: "form-group-bootstrap-toggle",
  components: {
    BootstrapToggle
  },
  props: {
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    value: Boolean,
    options: {
      type: Object,
      default: () => ({
        on: "Sim",
        off: "Não"
      })
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupBootstrapToggle.vue